import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CfetBaseComponent } from '../../cfet-core/components/cfet-base.component';


@Component({
    selector: 'app-utf-auth-single-id',
    templateUrl: './utf-auth-single-id.component.html',
    styleUrls: ['./utf-auth-single-id.component.scss'],
    standalone: false
})
export class UtfAuthSingleIdComponent extends CfetBaseComponent implements OnInit {

  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = true;
  stepTwoIcon = true;
  stepTwoSelected = true;
  stepTwoInformationpage: boolean;
  stepTwoProfileDone: boolean;
  stepTwoDone = false;
  openCancelModal = '';
  showCancelModal = false;
  progressTrackerStatus: any = 'registration';
  httpHeaders: any = {};
  amContactEmail: any;
  amUserId: any;
  amEmailVerified: any;
  amFirstName: any;
  amLastName: any;
  validEmail: boolean;
  accessToken: any;
  constructor(private route: ActivatedRoute, private title: Title) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.information.utfHtmlTitle);
    this.route.queryParams.subscribe((response: any) => {
      this.httpHeaders = response;
      this.amContactEmail = response.email;
      this.amEmailVerified = response.isEmailVerified;
      this.amFirstName = response.firstname;
      this.amLastName = response.lastname;
      this.amUserId = response.userid;
      this.accessToken = response.accessToken ? response.accessToken : '';
      if (this.amUserId && this.amUserId !== '') {
        const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
        this.validEmail = emailRegex.test(this.amUserId);
      }
      sessionStorage.setItem('AMUTFHeaders', JSON.stringify(this.httpHeaders));      
    });
  }

  handleProgressTrackerEvent (event) {
    this.progressTrackerStatus = event;
  }
}